<template>
  <div class="article-detail container">
    <div class="row">
      <div class="col-12">
        <img class="featured-image" :src="data.workeimage" :alt="data.title">
      </div>
    </div>
    <article class="detail-content container">
      <div class="row">
        <div class="col-blog">
          <h1>{{ data.title }}</h1>
        </div>
        <div class="col-blog" v-html="data.content"></div>
      </div>
    </article>
    <link-home></link-home>
  </div>
</template>

<script>
import LinkHome from '@/components/LinkHomeButton'
export default {
  metaInfo () {
    let data = this.data
    const titlePostfix = 'YUYAMA DESIGN INC. | ブランディング&デザイン | デザインコンサルティング'
    return {
      title: data ? data.title + ' | ' + titlePostfix : titlePostfix
    }
  },
  props: {
    data: Object
  },
  components: {
    LinkHome
  },
  data () {
    return {
      blogTitle: ''
    }
  },
  created () {
    this.blogTitle = this.data.title + ' | '
  },
  computed: {
    updateExcerpt () {
      if (this.data.workexcerpt === undefined) return ''
      return this.data.workexcerpt.replace(/[\n]/g, ' / ')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BlogDetail.vue